import { getErrorMessage } from '#/utils/error';

export interface EthereumProviderRpcError extends Error {
  readonly code: number;
  readonly data?: unknown;
}

export function getRpcError(err: unknown): EthereumProviderRpcError | null {
  if (err == null) throw new TypeError('Unexpected null or undefined');
  return (err as { code?: number }).code !== undefined
    ? (err as EthereumProviderRpcError)
    : null;
}

interface PreparedErrorMessage {
  message: string;
  isException: boolean;
}

export function prepareErrorMessage(
  step: string,
  err: unknown,
): PreparedErrorMessage {
  const rpcErrorMessage = getRpcError(err)?.message;
  const isException = rpcErrorMessage == null;
  const reason = rpcErrorMessage ?? getErrorMessage(err);
  const message = `${step}: ${String(reason)}`;

  return { message, isException };
}
